import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_separate_payment_block_on_sp~1&sex=male
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_separate_payment_block_on_sp/male'
					),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_separate_payment_block_on_sp~1&sex=male
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_separate_payment_block_on_sp/activity-male-chair-workouts'
					),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_separate_payment_block_on_sp~1&sex=male
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_separate_payment_block_on_sp/activity-male-walking'
					),
			},
		},
	},
]

export default config
